module.exports = __webpack_public_path__ + "static/iutmontreuil2010_logo-d0cdcc7196e21ab267808155cbfe290e.png";